export const objMayusculas = (item, noPermitido) => {
	let general = ['estatus', 'moneda', 'correo', 'email', 'master', 'paginaWeb', 'logo', 'contrasenna', 'web', 'numFactura', 'referencia', 'upc', 'password', 'rol', 'identificacion', 'imagen', 'numeroSerial', 'usuario']
	Object.keys(item).forEach(function (key) {
    let encontrado2 = []
    let encontrado = general.filter(gen => gen === key)
    if (noPermitido) encontrado2 =  noPermitido.filter(np => np === key)
    
      if (typeof item[key] === 'string' && item[key] && key.indexOf('id') === -1 && key.indexOf('cod') === -1 && encontrado.length === 0 && encontrado2.length === 0) {
        item[key] = item[key].toUpperCase()
      }
      else if(typeof item[key] === 'object' && item[key] && key !== 'Permisos' && key !== 'Empresa') {
        objMayusculas(item[key], noPermitido)
      }
      else if(typeof item[key] === 'array' && item[key] && key !== 'Permisos' && key !== 'Empresa') {
        mayusculas(item[key], noPermitido)
      }
    })
}

export const arrayMayusculas = (items, noPermitido) => {
  items.map(item => {
    objMayusculas(item, noPermitido)
  })
}

export const formatoDecimal = (i) => {
  let n = parseFloat(i).toFixed(2)
  return Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
